import  {eXcell,__extends} from './eXcell';

var eXcell_ch = (function (_super) {
    __extends(eXcell_ch, _super);
    function eXcell_ch(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_ch.prototype.disabledF = function (c) {
        if (c == true || c == 1) {
            this.cell.innerHTML = this.cell.innerHTML
                .replace("item_chk0.", "item_chk0_dis.")
                .replace("item_chk1.", "item_chk1_dis.");
        }
        else {
            this.cell.innerHTML = this.cell.innerHTML
                .replace("item_chk0_dis.", "item_chk0.")
                .replace("item_chk1_dis.", "item_chk1.");
        }
    };
    eXcell_ch.prototype.getValue = function () {
        return this.cell.chstate ? this.cell.chstate.toString() : "0";
    };
    eXcell_ch.prototype.isCheckbox = function () {
        return true;
    };
    eXcell_ch.prototype.isChecked = function () {
        if (this.getValue() == "1") {
            return true;
        }
        else {
            return false;
        }
    };
    eXcell_ch.prototype.setChecked = function (c) {
        this.setValue(c.toString());
    };
    eXcell_ch.prototype.detach = function () {
        return this.val != this.getValue();
    };
    eXcell_ch.prototype.changeState = function (c) {
        if (c === true && !this.grid.isActive) {
            if (window.globalActiveDHTMLGridObject != null &&
                window.globalActiveDHTMLGridObject != this.grid &&
                window.globalActiveDHTMLGridObject.isActive) {
                window.globalActiveDHTMLGridObject.setActive(false);
            }
            this.grid.setActive(true);
        }
        if (!this.grid.isEditable ||
            this.cell.parentNode._locked ||
            this.isDisabled()) {
            return;
        }
        if (this.grid.callEvent("onEditCell", [
            0,
            this.cell.parentNode.idd,
            this.cell._cellIndex
        ])) {
            this.val = this.getValue();
            if (this.val == "1") {
                this.setValue("0");
            }
            else {
                this.setValue("1");
            }
            this.cell.wasChanged = true;
            this.grid.callEvent("onEditCell", [
                1,
                this.cell.parentNode.idd,
                this.cell._cellIndex
            ]);
            this.grid.callEvent("onCheckbox", [
                this.cell.parentNode.idd,
                this.cell._cellIndex,
                this.val != "1"
            ]);
            this.grid.callEvent("onCheck", [
                this.cell.parentNode.idd,
                this.cell._cellIndex,
                this.val != "1"
            ]);
        }
        else {
            this.editor = null;
        }
        return true;
    };
    eXcell_ch.prototype.setValue = function (c) {
        this.cell.style.verticalAlign = "middle";
        if (c) {
            c = c.toString()._dhx_trim();
            if (c == "false" || c == "0") {
                c = "";
            }
        }
        if (c) {
            c = "1";
            this.cell.chstate = "1";
        }
        else {
            c = "0";
            this.cell.chstate = "0";
        }
        this.cell.setAttribute("excell", "ch");

        let checkCls=c==="0"?"ivu-icon ivu-icon-md-square-outline":"ivu-icon ivu-icon-md-checkbox";
        this.setCValue(`<span class="grid_check_box" onclick='new eXcell_ch(this.parentNode).changeState(true); (arguments[0]||event).cancelBubble=true; '  title=""><i  class="ivu-icon ${checkCls}"></i></span>`, this.cell.chstate);

        //
        // this.setCValue("<img src='" +
        //     this.grid.imgURL +
        //     "item_chk" +
        //     c +
        //     ".gif' onclick='new eXcell_ch(this.parentNode).changeState(true); (arguments[0]||event).cancelBubble=true; '>", this.cell.chstate);
    };
    return eXcell_ch;
})(eXcell);
window.eXcell_ch = eXcell_ch;

export default eXcell_ch;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_ch.js